export default __webpack_public_path__ + "static/media/akustikdecken4.b7fcf227.jpg";